<template>
  <Gathering />
</template>

<script>
import Gathering from '@/components/content/gathering/index.vue'

export default {
  name: 'GatheringPage',
  components: { Gathering }
}
</script>

<style scoped>

</style>
